import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { styled as materialStyled } from "@mui/material/styles";
import { DateRangeRounded } from "@mui/icons-material";

import "./css/daterangepicker.css";
import "./css/bs.css";

import { StyledDateRangePicker } from "./styled/StyledDateRangePicker";
import { ALL_DATES, locale } from "./NuDateUtils";

export function SelectDateRange({
    startDate,
    endDate,
    ranges,
    disabled,
    dateChanged,
    handleEvent
}) {
    const start = startDate.format(locale.format);
    const end = endDate.format(locale.format);
    const label = start === end ? start : `${start} - ${end}`;
    return (
        <DateRangeDiv>
            <StyledDateRangePicker
                initialSettings={{
                    ranges,
                    startDate,
                    endDate,
                    locale,
                    linkedCalendars: false,
                    showDropdowns: true,
                    minDate: ALL_DATES.startDate,
                    maxDate: ALL_DATES.endDate
                }}
                disabled={disabled}
                onApply={dateChanged}
                onEvent={handleEvent}
            >
                <Autocomplete
                    type="text"
                    value={label}
                    readOnly
                    disabled={disabled}
                    data-testid="date-range-select"
                />
            </StyledDateRangePicker>
            <DateIcon data-testid="date-range-icon" aria-hidden="true" />
        </DateRangeDiv>
    );
}

export const DateRangeDiv = styled.div`
    position: relative;
    float: left;
    margin: 0 3px;
`;

export const DateIcon = materialStyled(DateRangeRounded)({
    position: "absolute",
    right: "6px",
    top: "6px",
    fontSize: "1rem"
});

export const Autocomplete = styled.input`
    background: transparent;
    border: 1px solid #aaa;
    height: 29px;
    padding: 5px;
    width: 227px;
`;

SelectDateRange.propTypes = {
    dateChanged: PropTypes.func,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    disabled: PropTypes.bool,
    ranges: PropTypes.object,
    handleEvent: PropTypes.func
};
